import React from "react";
import Sidebar from "./Sidebar.tsx";
import Topbar from "./Topbar.tsx";
import Login from "./Login.tsx";
import { Outlet, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./CSS/Adminpanel.css";
export default function AdminPanel() {
  return (
    <div className="admin-container">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="main-content">
        <Topbar></Topbar>
        <div className="content-area">
          {/* Use relative paths */}
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
}
